export default "__VITE_ASSET__DCz$Tsln__"